import React from 'react';
import {
  Card,
  CardContent,
  Skeleton,
  Box,
} from '@mui/material';

export const RepositoryCardSkeleton: React.FC = () => {
  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '22px',
        border: '1px solid #e8ecf1',
        bgcolor: '#ffffff',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06), 0 2px 6px rgba(15, 23, 42, 0.03)',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ px: 2.5, pt: 2.25, pb: 2, flexGrow: 1 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
          <Box sx={{ flex: 1, mr: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
              <Skeleton variant="rounded" width={26} height={26} sx={{ borderRadius: '8px', bgcolor: '#f1f5f9' }} />
              <Skeleton variant="text" width="55%" height={22} sx={{ bgcolor: '#f1f5f9' }} />
            </Box>
            <Skeleton variant="text" width="70%" height={16} sx={{ ml: '34px', bgcolor: '#f1f5f9' }} />
          </Box>
          <Skeleton variant="circular" width={60} height={60} sx={{ bgcolor: '#f1f5f9', flexShrink: 0 }} />
        </Box>

        {/* Metadata */}
        <Box sx={{ display: 'flex', gap: 1, ml: '34px', mb: 2 }}>
          <Skeleton variant="rounded" width={50} height={14} sx={{ borderRadius: '4px', bgcolor: '#f1f5f9' }} />
          <Skeleton variant="rounded" width={60} height={14} sx={{ borderRadius: '4px', bgcolor: '#f1f5f9' }} />
        </Box>

        {/* Category bars */}
        <Skeleton variant="text" width="30%" height={14} sx={{ mb: 1, bgcolor: '#f1f5f9' }} />
        {[1, 2, 3].map((i) => (
          <Box key={i} sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Skeleton variant="text" width={70} height={16} sx={{ bgcolor: '#f1f5f9' }} />
              <Skeleton variant="text" width={24} height={16} sx={{ bgcolor: '#f1f5f9' }} />
            </Box>
            <Skeleton variant="rounded" width="100%" height={4} sx={{ borderRadius: 2, bgcolor: '#f1f5f9' }} />
          </Box>
        ))}
      </CardContent>

      {/* Footer */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2.5,
          py: 1.25,
          borderTop: '1px solid #f1f5f9',
        }}
      >
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Skeleton variant="rounded" width={70} height={28} sx={{ borderRadius: '10px', bgcolor: '#f1f5f9' }} />
          <Skeleton variant="rounded" width={70} height={28} sx={{ borderRadius: '10px', bgcolor: '#f1f5f9' }} />
        </Box>
        <Skeleton variant="rounded" width={72} height={30} sx={{ borderRadius: '10px', bgcolor: '#f1f5f9' }} />
      </Box>
    </Card>
  );
};